import { render, staticRenderFns } from "./Post_Section_CommentStats.vue?vue&type=template&id=21375670&"
import script from "./Post_Section_CommentStats.vue?vue&type=script&lang=js&"
export * from "./Post_Section_CommentStats.vue?vue&type=script&lang=js&"
import style0 from "./Post_Section_CommentStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports